<template>
  <component
    v-bind="$attrs"
    :is="href === '#' ? 'button' : 'InertiaLink'"
    class="group relative rounded-full p-2 transition-colors hover:bg-neutral-50 hover:text-current"
    :href="href"
    prefetch="hover"
  >
    <div
      v-if="hasRedIndicator"
      class="bg-error-500 absolute rounded-full border-2 border-white text-white transition-colors group-hover:border-neutral-50"
      :class="[
        indicatorValue
          ? 'top-0 right-0 inline-flex h-5 w-5 items-center justify-center'
          : 'top-1 right-1 h-3 w-3',
        indicatorValue > 99 ? 'text-[8px]' : 'text-[10px]',
      ]"
    >
      {{ isIndicatorValueSet ? formattedIndicatorValue : '' }}
    </div>
    <span class="sr-only">{{ screenReaderText }}</span>
    <slot />
  </component>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  hasRedIndicator: {
    type: Boolean,
    default: false,
  },
  indicatorValue: {
    type: Number,
    default: 0,
  },
  screenReaderText: {
    type: String,
    required: true,
  },
  href: {
    type: String,
    default: '#',
  },
})

const isIndicatorValueSet = computed(() => props.indicatorValue > 0)
const formattedIndicatorValue = computed(() =>
  props.indicatorValue > 99 ? '99+' : props.indicatorValue,
)
</script>
